// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import './application/forms';
import '../stylesheets/application.scss';

require("@rails/ujs");
require("@rails/activestorage").start();
require("./application/channels");

// Alpine.js library
import 'alpinejs'

import Rails from '@rails/ujs'
window.Rails = Rails;
Rails.start();

// Swal library
import './application/sweet-alert-confirm';

// Support component names relative to this directory:
let componentRequireContext = require.context("components", true);
let ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
